import styled from '@emotion/styled'

export const Container = styled.div`
  display: flex;
  flex-direction: column;
`

export const ChildrenContainer = styled.div<{ isVisible: boolean }>`
  display: ${({ isVisible }) => (isVisible ? 'block' : 'none')};
`

export const Item = styled.div<{
  hasChildren: boolean
  highlighted?: boolean
  isReadOnly?: boolean
  isVisible: boolean
  level: number
}>`
  display: flex;
  align-items: center;
  padding-left: ${({ level }) => level * 20}px;
  background-color: ${({ highlighted, isVisible, level }) => {
    if (highlighted && isVisible) {
      return '#f0f6f7'
    }
    if (highlighted) {
      return 'var(--InfoBG)'
    }

    if (level === 0) {
      return '#f5f5f5'
    }
    return '#FAFAFA'
  }};
  padding: 1rem;
  border-radius: 4px;
  justify-content: space-between;
  cursor: ${({ hasChildren }) => (hasChildren ? 'pointer' : 'default')};
  margin-top: ${({ level }) => (level === 0 ? '0.5rem' : '0')};
  border-bottom: ${({ hasChildren, isVisible, level }) =>
    level === 0 && isVisible && hasChildren ? '1px solid var(--White90)' : 'none'};
  &:hover {
    background: ${({ highlighted, isReadOnly, isVisible }) => {
      if (isReadOnly) return 'var(--White98)'
      if (highlighted && isVisible) {
        return '#eaf0f1'
      }
      if (highlighted) {
        return '#f0f6f8'
      }
      if (isVisible) {
        return 'var(--White94)'
      }
      return 'var(--White96)'
    }};
  }
`

export const Label = styled.div<{
  checked?: boolean
  isReadOnly?: boolean
}>`
  display: flex;
  align-items: center;
  gap: 0.5rem;
  cursor: ${({ isReadOnly }) => (!isReadOnly ? 'pointer' : 'default')};
  padding: 4px 6px;
  border-radius: 4px;
  &:hover {
    background: ${({ isReadOnly }) => {
      if (isReadOnly) {
        return 'transparent'
      }
      return 'var(--White90)'
    }};
    input ~ .checkmark {
      background-color: ${({ checked, isReadOnly }) => {
        if (!checked) {
          if (isReadOnly) {
            return 'var(--White90)'
          }
          return 'var(--White)'
        }
      }};
    }
  }
`
